export default {
  ROUTES: {
    QUICK_BUY: { NAME: 'quick-buy', PATH: '/quick-buy' },
  },
}
